import { Navigate } from "react-router";
import { useGetUserAddressQuery } from "../../../apis/UserAddress.api";
import { PrimaryUserAddress, UserAddress } from "../../../types/models/UserAddress";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const UserAddressScoped = () => {
    const {
        data,
    } = useGetUserAddressQuery(PrimaryUserAddress.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/user-addresses/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default UserAddressScoped;
